module.exports = __webpack_public_path__ + "img/ic_64_feature_lieblingsteam.22d526f5.svg";